// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"80":"e164b3b8","210":"d19ee749","219":"73ce8ccc","237":"c5f723be","336":"c0158c49","965":"48b96d97"}[chunkId] + ".chunk.css";
};